import { Injectable } from "@angular/core";
import { Observable, ReplaySubject } from "rxjs/Rx";
import { Subject } from "rxjs/Subject";
import { PruHttpService } from "./pru-http.service";
import { CookieService } from "ngx-cookie-service";
import { FeatureListService } from "../services/feature-list.service";


declare var environment: any;

@Injectable({
  providedIn: "root"
})
export class GenericService {
  public resArr: any;
  public AggDataArr: any;
  dataServiceObj: any;
  private resArrObs: Subject<any> = new Subject();
  public resArrObs$ = this.resArrObs.asObservable();
  public AggDataArrObs = new Subject();
  private urls: Observable<any>;
  contCount: number;
  displayCont: boolean;
  fallBack: boolean;
  srvcData: any;
  appTitle: string;
  aggUser: boolean;
  userName: string;
  userSsoid: string;
  public aggData: any;
  public aggExtData: any;
  private dynamicContractsData: any;
  public initData: any;
  private aggSummary: number;
  public initDataObs = new Subject();
  public filteredCont: any;
  public filteredContObs = new Subject();
  public spinner: boolean = true;
  public xPruId: any;
  usr_rspar: boolean = false;
  public usr_csr: boolean = false;
  redesign: boolean = false;
  redesignFt1: boolean = false;
  redesignFt2: boolean = false;
  public toggleObs: ReplaySubject<any> = new ReplaySubject();
  public toggleObs$ = this.toggleObs.asObservable();

  public toggleFeatures: ReplaySubject<any> = new ReplaySubject();
  public toggleFeatures$ = this.toggleFeatures.asObservable();

  public nudgeObs: ReplaySubject<any> = new ReplaySubject();
  public nudgeObs$ = this.nudgeObs.asObservable();
  outage = false;
  userBUs = [];
  showDems = environment.showDems;
  retCntrUrl: string;
  constructor(
    private PruHTTP: PruHttpService,
    private cookieService: CookieService,
    private _featureListService: FeatureListService
  ) {
    this.contCount = 0;
    this.displayCont = false;
    this.fallBack = false;
    this.resArr = [];
    this.aggExtData = null;
    this.dataServiceObj = [];
    this.AggDataArr = [];
    this.srvcData = {};
    this.appTitle = "";
    this.aggData = [];
    this.filteredCont = [];
    this.aggUser = false;
    // setTimeout(() => {
    //   if (this.spinner) {
    //     /*this.spinner = false;*/ this.updateSpinner();
    //   }
    // }, 16000);
  }

  pushWCMData(jsonObj) {
    this.initData = [];
    this.initData.push(jsonObj);
    this.initDataObs.next(jsonObj);
  }

  pushFilteredData(jsonObj) {
    this.filteredCont.push(jsonObj);
    this.filteredContObs.next(jsonObj);
  }

  updateAppName(app: string) {
    this.appTitle = app;
  }

  // updateDisplayFlag(val) {
  //   this.displayCont = val;
  // }

  // updateFallBackFlag(val) {
  //   this.fallBack = val;
  // }

  updateContainerCount(val: number) {
    this.contCount = val;
  }

  updateMsgArr(obj) {
    this.srvcData = obj;
  }

  updateResArr(jsonObj) {
    this.resArr.push(jsonObj);
    this.resArrObs.next(jsonObj);
  }

  addAggData(obj) {
    if (this.aggExtData) {
      // this.contCount = this.contCount - 1;
      this.resArr.forEach((ele, index) => {
        if (ele && ele.contractSummary && ele.contractSummary.length > 0) {
          for (let i = 0; i < ele.contractSummary.length; i++) {
            if (
              ele.contractSummary[i] &&
              ele.contractSummary[i].accountType &&
              ele.contractSummary[i].accountType === "external account"
            ) {
              this.resArr.splice(index, 1);
              break;
            }
          }
        }
      });
    }
    // this.contCount = this.contCount++;
    this.aggExtData = obj;
    this.updateResArr(this.aggExtData);
  }

  // keeping aligned with agg for now
  addDynamicProductTypeData(contractsInfo: any, productTypeCode: string) {
    if (this.dynamicContractsData) {
      this.resArr.forEach((ele, index) => {
        if (ele && ele.contractSummary && ele.contractSummary.length > 0) {
          for (let i = 0; i < ele.contractSummary.length; i++) {
            if (
              ele.contractSummary[i] &&
              ele.contractSummary[i].productTypeCode === productTypeCode
            ) {
              this.resArr.splice(index, 1);
              break;
            }
          }
        }
      });
    }

    this.dynamicContractsData = contractsInfo;
    this.updateResArr(this.dynamicContractsData);
  }

  setExtAggUser(flag) {
    this.aggUser = flag;
  }
  retExtAggUser() {
    return this.aggUser;
  }
  updateAggDataArr(jsonObj) {
    this.AggDataArr.push(jsonObj);
    this.AggDataArrObs.next(jsonObj);
  }

  updateAggrData(obj: any) {
    this.aggData.push(obj);
  }

  retContractSummary(obj: any) {
    if (obj && obj["contractSummary"]) {
      return obj["contractSummary"];
    } else {
      return null;
    }
  }


  /**
   * Generic Service load the url from appconfig
   */
  getAppConfig(appName: string): Observable<any> {
    let service = "service." + appName;
    return this.PruHTTP.get(service, "AppConfig");
  }

  getServiceData(
    serviceURL: string,
    serviceFlag: string,
    params?: any
  ): Observable<any> {
    // if ( callingMethod !== 'post') {
    return this.PruHTTP.get(
      serviceURL,
      serviceFlag ? serviceFlag : "GenericService",
      params
    );
    //  }
  }

  collapseView() {
    this.pushFilteredData(null);
  }

  expandView(cont, key) {
    let filteredContracts = [],
      extContracts = [],
      intContracts = [];
    if (this.filteredCont && this.filteredCont.length > 0) {
      this.filteredCont = [];
    }
    if (key.toLowerCase() === "assets") {
      this.aggSummary = 0;
    } else if (key.toLowerCase() === "income") {
      this.aggSummary = 1;
    } else if (key.toLowerCase() === "protection") {
      this.aggSummary = 2;
    }
    if (cont) {
      cont.forEach(element => {
        if (element && element.primaryContractValue) {
          if (
            element.accountType &&
            element.accountType.toLowerCase() === "external account"
          )
            extContracts.push(element);
          else intContracts.push(element);
        }
      });
    }
    filteredContracts = intContracts.concat(extContracts);
    this.pushFilteredData(filteredContracts);
  }

  /**
   * wcmImpl: Handles the data for init load.
   */
  wcmImpl() {
    //  console.log('wcmImpl', this.appTitle);
    if (this.appTitle) {
      let temp = {};
      let sessionobject = sessionStorage.getItem("userPzn");
      if (sessionobject) {
        temp = JSON.parse(sessionobject);
        //    console.log('wcmImpl contents', temp['contents']);
        this.pushWCMData(temp);
      }
      return temp;
    }
  }

  // updateSpinner(): void {
  //   if (this.spinner) {
  //     try {
  //       window.dispatchEvent(new Event('allDone'));
  //     } catch (err) {
  //       var event = document.createEvent('Event');
  //       event.initEvent('allDone', true, true);
  //       document.dispatchEvent(event);
  //     }
  //   }

  //   this.spinner = false;
  // }

  /* doSurvey(): void {
    let ddo = JSON.parse(sessionStorage.getItem("currentDdo"));
    let userSso = ddo.user.profile.profileInfo.pruId
      ? ddo.user.profile.profileInfo.pruId
      : "";
    let surveyUrl = "https://www.surveymonkey.com/r/RHCZQVJ?id=" + userSso;
    const left = screen.width / 2 - 200;
    const top = screen.height / 2 - 250;
    let custOU = window["custOU"] ? window["custOU"] : "";
    if (custOU) {
      surveyUrl += "&bu=" + custOU;
    }
    window.open(
      surveyUrl,
      "",
      "top=" +
        top +
        ",left=" +
        left +
        "toolbar=no, scrollbars=yes, resizable=yes, width=800, height=600"
    );
  } */

  frameUrl(val) {
    if (val) {
      if (/http/i.test(val)) {
        return val;
      } else {
        return environment.PUBLIC_RENDER_DOMAIN + val;
      }
    } else return "";
  }

  callUiLogger(val) {
    let logString = val ? val : "no response";
    let clientGlobSess = this.cookieService.get("X-PruGlobalSessionID");
    this.PruHTTP.post(
      "/api/public/utility/uilogger",
      "MyAccounts - contractSummary: Client X-PruGlobalSessionID " +
      clientGlobSess +
      " " +
      logString
    ).subscribe(
      res => {
        let logOutUrl = this.cookieService.get("MYACCTLOGOUT");
        window.location.href = logOutUrl;
      },
      error => {
        let logOutUrl = this.cookieService.get("MYACCTLOGOUT");
        window.location.href = logOutUrl;
      }
    );
  }

  openSecondary($event, messageTarget, messageLink, popupWidth, popupHeight) {
    /*TODO: CSR support*/
    if (messageTarget) {
      if (/blank/i.test(messageTarget)) {
        $event.preventDefault();
        window.open(messageLink, "_blank");
      }
      if (/popup/i.test(messageTarget)) {
        $event.preventDefault();
        popupWidth = popupWidth ? popupWidth : 800;
        popupHeight = popupHeight ? popupHeight : 600;
        var left = screen.width / 2 - 200,
          top = screen.height / 2 - 250;
        window.open(
          messageLink,
          "",
          "top=" +
          top +
          ",left=" +
          left +
          "toolbar=no, scrollbars=yes, resizable=yes, width=" +
          popupWidth +
          ", height=" +
          popupHeight
        );
      }
    }
  }

  checkLogOutCookie() {
    let logOutCookie = this.cookieService.get("MYACCTLOGOUT");
    let visitedSystemsCookie = this.cookieService.get("VisitedSystems");
    var fallbacklogout =
      "https://" + document.location.host + "/ucd/logout/logout.html";
    if (!logOutCookie || !/myaccounts/.test(logOutCookie)) {
      document.cookie =
        "MYACCTLOGOUT=" +
        fallbacklogout +
        "; path=/; SameSite=Lax;Secure;domain=.prudential.com";
    }
    if (!visitedSystemsCookie) {
      document.cookie =
        "VisitedSystems=MYACCT; path=/; SameSite=Lax;Secure;domain=.prudential.com";
    }
  }

  getToggleFeatures(): Observable<boolean> {
    return this._featureListService.getFeatureList();
  }
}